import { Link } from 'react-router-dom';
import { navLinks } from '@/mocks/homeMocks';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="text-2xl font-heading font-bold text-primary-500">aigei</Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              国内领先的游戏素材、音效、音乐及视觉资源免费下载平台。让创作更简单，让创意无限可能。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="GitHub">
                <i className="ri-github-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-950 mb-4">素材分类</h4>
            <ul className="space-y-2.5">
              {navLinks.filter(l => l.href.startsWith('/category')).map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-950 mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">联系我们</Link></li>
              <li><a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">创作者入驻</a></li>
              <li><a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">商务合作</a></li>
              <li><a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">用户协议</a></li>
              <li><a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">隐私政策</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-950 mb-4">帮助中心</h4>
            <ul className="space-y-2.5">
              <li><a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">新手指南</a></li>
              <li><a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">常见问题</a></li>
              <li><a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">授权说明</a></li>
              <li><a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">上传规范</a></li>
              <li><a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">意见反馈</a></li>
            </ul>
            <div className="mt-4">
              <p className="text-sm text-foreground-500">客服热线</p>
              <p className="text-lg font-medium text-primary-500">400-888-9999</p>
              <p className="text-xs text-foreground-400 mt-1">周一至周五 9:00 - 18:00</p>
            </div>
          </div>
        </div>

        <div className="py-5 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-foreground-400">
            &copy; 2018-2024 aigei.com 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <p className="text-xs text-foreground-400">
            Made with <span className="text-primary-500">&hearts;</span> for creators
          </p>
        </div>
      </div>
    </footer>
  );
}